
import './App.css';

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import Footer from './pages/Footer';
import AboutUs from './components/AboutUs';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Services from './pages/Services';
import ContactInfo from './pages/Contact';
import Enquiry from './pages/Enquiry';
import GallerySection from './pages/GallerySection';
import Booking from './pages/Booking';
import Urbaniaonrentinpune from './pages/Urbania On Rent Pune';
import Packages from './pages/Packages';
import Urbaniaonrentinpimpri from './pages/Urbania on Rent in Pimpri Chinchwad';
import Urbaniahireforcorporateeventsinpune from './pages/Urbania Hire for Corporate Events in Pune';
import Sevntinseaterurbaniaonrentinpuune from './pages/17 Seater Urbania on Rent in Pune';
import Fourtinseaterurbania from './pages/14 Seater Urbania on Rent in Pune';
import Urbaniaonrentinkharadi from './pages/Urbania on Rent in Kharadi';
import Urbaniaonrentinhadapsar from './pages/Urbania on Rent in Hadapsar';
import Urbaniaonrentinkothrud from './pages/Urbania on Rent in Kothrud';
import Urbaniaonrentinbalewadi from './pages/Urbania On Rent in Bibwewadi';
import Urbaniaonrentinkoregaonpark from './pages/Urbania on Rent in Koregaon Park';
import Urbaniaonrentinkalyaninagar from './pages/Urbania On Rent in Kalyani Nagar';
import Urbaniaonrentinmundhwapune from './pages/Urbania On Rent in Mundhwa Pune';
import Urbaniabusonrentinbaner from './pages/Urbania Bus On Rent in Baner';
import Urbaniaacbusonrentinaundh from './pages/Urbania Ac Bus On Rent in Aundh';
import Urbaniabusonrentinhinjewadi from './pages/Urbania Bus On Rent in Hinjewadi';
import Urbaniaonrentinbhosari from './pages/Urbania on Rent in Bhosari';
import Urbaniaonrentinpunestation from './pages/Urbania on Rent in Pune Station';
import Urbaniaonrentinchakan from './pages/Urbania On Rent in Chakan';
import Urbaniaonrentinmoshi from './pages/Urbania On Rent in Moshi';
import Urbaniaonrentincharholi from './pages/Urbania On Rent in Charholi Budruk';
import Urbaniaonrentinnigdipradhikaran from './pages/Urbania On Rent in Nigdi Pradhikaran';
import Urbaniaonrentinlohegaon from './pages/Urbania On Rent in Lohegaon';
import Urbaniaonrentinwagholi from './pages/Urbania On Rent in Wagholi';
import Urbaniarentalserviceinpune from './pages/Urbania Rental Service in Pune';
import Besturbaniaonrentinpune from './pages/Best Urbania on Rent in Pune';
import Affordableurbaniaonrentinpune from './pages/Affordable Urbania on Rent Pune';
import Acurbaniaonrentinpune from './pages/AC Urbania on Rent Pune';
import Luxuryurbaniaonrentpune from './pages/Luxury Urbania on Rent Pune';
import Nonacurbaniaonrentinpune from './pages/Non AC Urbania on Rent Pune';
import Urbaniafordestinationinpune from './pages/Urbania for Outstation in Pune';
import Urbaniaforpunetoshirdionrent from './pages/Urbania for Pune to Shirdi On Rent';
import Urbaniaforpunetonashikonrent from './pages/Urbania for Pune to Nashik On Rent';
import Urbaniaforpunetomahabaleshwarhire from './pages/Urbania for Pune to Mahabaleshwar Hire';
import Urbaniaforpunetogoatour from './pages/Urbania for Pune to Goa Tour Package';
import Urbaniaforpunetokolhapur from './pages/Urbania for Pune to Kolhapur On Rent';
import Urbaniaforpunetoaurangabad from './pages/Urbania for Pune to Aurangabad on Rent';
import Punetolonavala from './pages/Pune to Lonavala Urbania On Rent';
import Urbanionrentinforround from './pages/Urbania On Rent for Round Trip Pune';
import Urbaniatravellerrentinpune from './pages/Urbania Traveller Rent in Pune';
import Urbaniamonthlycorporatehire from './pages/Urbania Monthly Corporate Hire Pune';
import Corporateurbaniarentalservice from './pages/Corporate Urbania Rental Services Pune';
import Urbaniahireforpicnic from './pages/Urbania Hire for Picnic in Pune';
import Urbaniahireforlocaltripinpune from './pages/Urbania Hire for Local Trip in Pune';
import Urbaniaonrentforpuneairport from './pages/Urbania On Rent for Pune Airport';
import Punetomumbaiurbaniaonrent from './pages/Pune to Mumbai Urbania On Rent';
import Urbaniaforweddingevents from './pages/Urbania for Wedding Events in Pune';
import Urbaniaperkmrateinoune from './pages/Urbania per km rate in Pune';
import Cheapesturbaniarentalservice from './pages/Cheapest Urbania Rental Service in Pune';
import ACurbaniaonrrentinakurdi from './pages/AC Urbania on Rent in Akurdi Pune';
import Urbaniaonrentinwakad from './pages/Urbania On Rent in Wakad';
import Luxuryurbaniaonrentinpashan from './pages/Luxury Urbania On Rent in Pashan';
import Urbaniaonrentinbalewadii from './pages/Urbania On Rent in Balewadi';
import Urbaniaonrentinsangvi from './pages/Urbania On Rent in Sangvi';
import Urbaniabushireinchikhali from './pages/Urbania Bus Hire in Chikhali';
import Urbaniaonrentintalawade from './pages/Urbania On Rent in Talawade MIDC';
import Urbaniaonrentinpurandar from './pages/Urbania On Rent in Purandar Airport';
import Urbaniaonrentinravet from './pages/Urbania on Rent in Ravet & Punawale';
import Urbaniaonrentinrajgurunagar from './pages/Urbania On Rent in Rajgurunagar Khed';
import Urbaniabusonrentinjunnar from './pages/Urbania Bus On Rent in Junnar Pune';
import Urbaniaonrentinambegaon from './pages/Urbania on Rent in Ambegaon Pune';
import Urbaniabusonrent from './pages/Urbania Bus On Rent in Shirur';
import Urbaniaburhireinmaval from './pages/Urbania Bus Hire in Maval';
import Urbaniaonrentinmulshi from './pages/Urbania On Rent in Mulshi';
import Urbaniaonrentindaund from './pages/Urbania On Rent in Daund';
import Urbaniaonrentinbhor from './pages/Urbania On Rent in Bhor';
import Urbaniaonrentpurandar from './pages/Urbania On Rent in Purandar';
import Urbaniaonrentinindapur from './pages/Urbania On Rent in Indapur';
import Urbaniaonrentinvelhe from './pages/Urbania On Rent in Velhe';
import Urbaniaonrentinmumbai from './pages/Urbania On Rent in Mumbai';
import Forceurbaniaonrentinnavimumbai from './pages/Force Urbania On Rent in Navi Mumbai';
import Luxuryurbaniabushireinthane from './pages/Luxury Urbania Bus Hire in Thane';
import Urbaniabusonrentinmumbai from './pages/Urbania Bus On Rent in Mumbai Airport';
import Luxuryurbaniaonrentinlonavala from './pages/Luxury Urbania On Rent in Lonavala';
import Urbaniaonrentinkolhapur from './pages/Urbania On Rent in Kolhapur';
import Urbaniabusonrentinsangli from './pages/Urbania Bus On Rent in Sangli';
import Urbaniabusonrentinsolapur from './pages/Urbania Bus On Rent in Solapur';
import Urbaniabusonrentinshirdi from './pages/Urbania Bus On Rent in Shirdi';
import Luxuryurbaniabusrentalinnashik from './pages/Luxury Urbania Bus Rentals in Nashik';
import Luxuryurbaniarentalsinahemednagar from './pages/Luxury Urbania Rentals in Ahmednagar';
import Acluxuryurbaniahireinmahabaleshwar from './pages/AC Luxury Urbania Hire in Mahabaleshwar';
import Punetokonkandarshanurbaniabuspackage from './pages/Pune to Konkan Darshan Urbania Bus Package';
import Minibusonrentinpune from './pages/Mini Bus On Rent in Pune';
import Minibusonrentalinpimprichichwad from './pages/Mini Bus On Rental in Pimpri Chinchwad';
import Fifteenseateracminiluxury from './pages/15 Seater AC Mini Luxury Bus On Rent Pune';
import Forceurbaniaonrentinsatara from './pages/Force Urbania On Rent in Satara';
import Forceurbaniaonrentinkatrajpune from './pages/Force Urbania on Rent in Katraj Pune';
import Forceurbaniaonrentinshivajinagar from './pages/Force Urbania On Rent in Shivaji Nagar Pune';
import Urbaniaonrentforjyotilinga from './pages/Urbania on Rent for Jyotirlinga Darshan from Pune';
import Punetoujjainurbaniabushire from './pages/Pune to Ujjain Urbania Bus Hire';
import Punetoashtavinayakdarshan from './pages/Pune to Ashtavinayak Darshan Urbania Bus';
import Urbaniatouristbusonrent from './pages/Urbania Tourist Bus On Rent in Pune';
import Punetopandharpururbaniatour from './pages/Pune to Pandharpur Urbania Tour Package';
import Urbaniabusonrentinnashik from './pages/Urbania Bus On Rent in Nashik';
import Punetoayodhyaurbaniabus from './pages/Pune to Ayodhya Urbania Bus On Rent';
import Punetobhimashankar from './pages/Pune to Bhimashankar Urbania Hire';
import Punetohyderabadurbania from './pages/Pune to Hyderabad Urbania On Rent';
import Punetobangloreurbania from './pages/Pune to Bangalore Urbania Rental Service';
import Punetorajshthanurbania from './pages/Pune to Rajasthan Urbania Rental Service';
import Busonrentinpune from './pages/Bus On Rent Pune';
import Urbaniaonrentinaurangabad from './pages/Urbania On Rent in Aurangabad';
import Bushireforweddinginpune from './pages/Bus Hire for Wedding in Pune';
import Urbaniaonrentpuneforwedding from './pages/Urbania on Rent Pune for Wedding Functions';
import Punetooutstationurbaniaonrent from './pages/Pune to Outstation Urbania on Rent';
import Urbaniabusonrentinpunewala from './pages/Urbania Bus on Rent in Punawale';
import Urbaniahireinpimprichichwad from './pages/Urbania Hire in Pimpri for Corporate Travel';
import Busrentalserviceinsaswad from './pages/Bus Rental Service in Saswad Pune';
import Urbaniaonrentinpunecontact from './pages/Urbania on Rent in Pune Contact Number';
import OurFleet from './pages/OurFleet';
import ContactButtons from './components/ContactButtons';
import ScrollToTop from './components/ScrollToTop';
import UrbaniaNetwork from './pages/Our Network';
import Career from './pages/Career';
import Nineseaterurbaniaonrentinpune from './pages/9 Seater Urbania On Rent in Pune';
import Onethreeseaterurbaniaonrentinpune from './pages/13 Seater Urbania On Rent in Pune';
import Onezeroseaterurbaniaonrentinpune from './pages/10 Seater Urbania On Rent in Pune';
import Punetonashikurbaniabushire from './pages/Pune to Nashik Urbania Bus Hire';

function App() {
  return (
    <Router>
<Header/>
      <ContactButtons />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<ContactInfo />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/gallery" element={<GallerySection />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/our-fleet" element={<OurFleet />} />
        <Route path="/Career" element={<Career />} />
        <Route path="/Our-Network" element={<UrbaniaNetwork />} />
        <Route path="/urbania-on-rent-pune" element={<Urbaniaonrentinpune />} />
       
<Route path="/urbania-on-rent-in-pimpri-chinchwad" element={<Urbaniaonrentinpimpri />} />
<Route path="/urbania-hire-for-corporate-events-in-pune" element={<Urbaniahireforcorporateeventsinpune />} />
<Route path="/17-seater-urbania-on-rent-in-pune" element={<Sevntinseaterurbaniaonrentinpuune />} />
<Route path="/14-seater-urbania-on-rent-in-pune" element={<Fourtinseaterurbania />} />
<Route path="/urbania-on-rent-in-kharadi" element={<Urbaniaonrentinkharadi />} />
<Route path="/urbania-on-rent-in-hadapsar" element={<Urbaniaonrentinhadapsar />} />
<Route path="/urbania-on-rent-in-kothrud" element={<Urbaniaonrentinkothrud />} />
<Route path="/urbania-on-rent-in-bibwewadi" element={<Urbaniaonrentinbalewadi />} />
<Route path="/urbania-on-rent-in-koregaon-park" element={<Urbaniaonrentinkoregaonpark />} />
<Route path="/urbania-on-rent-in-kalyani-nagar" element={<Urbaniaonrentinkalyaninagar />} />
<Route path="/urbania-on-rent-in-mundhwa-pune" element={<Urbaniaonrentinmundhwapune />} />
<Route path="/urbania-bus-on-rent-in-baner" element={<Urbaniabusonrentinbaner />} />
<Route path="/urbania-ac-bus-on-rent-in-aundh" element={<Urbaniaacbusonrentinaundh />} />
<Route path="/urbania-bus-on-rent-in-hinjewadi" element={<Urbaniabusonrentinhinjewadi />} />
<Route path="/urbania-on-rent-in-bhosari" element={<Urbaniaonrentinbhosari />} />
<Route path="/urbania-on-rent-in-pune-station" element={<Urbaniaonrentinpunestation />} />
<Route path="/urbania-on-rent-in-chakan" element={<Urbaniaonrentinchakan />} />
<Route path="/urbania-on-rent-in-moshi" element={<Urbaniaonrentinmoshi />} />
<Route path="/urbania-on-rent-in-charholi-budruk" element={<Urbaniaonrentincharholi />} />
<Route path="/urbania-on-rent-in-nigdi-pradhikaran" element={<Urbaniaonrentinnigdipradhikaran />} />
<Route path="/urbania-on-rent-in-lohegaon" element={<Urbaniaonrentinlohegaon />} />
<Route path="/urbania-on-rent-in-wagholi" element={<Urbaniaonrentinwagholi />} />
<Route path="/urbania-rental-service-in-pune" element={<Urbaniarentalserviceinpune />} />
<Route path="/best-urbania-on-rent-in-pune" element={<Besturbaniaonrentinpune />} />
<Route path="/affordable-urbania-on-rent-pune" element={<Affordableurbaniaonrentinpune />} />
<Route path="/ac-urbania-on-rent-pune" element={<Acurbaniaonrentinpune />} />
<Route path="/luxury-urbania-on-rent-pune" element={<Luxuryurbaniaonrentpune />} />
<Route path="/non-ac-urbania-on-rent-pune" element={<Nonacurbaniaonrentinpune />} />
<Route path="/urbania-for-outstation-in-pune" element={<Urbaniafordestinationinpune />} />
<Route path="/urbania-for-pune-to-shirdi-on-rent" element={<Urbaniaforpunetoshirdionrent />} />
<Route path="/urbania-for-pune-to-nashik-on-rent" element={<Urbaniaforpunetonashikonrent />} />
<Route path="/urbania-for-pune-to-mahabaleshwar-hire" element={<Urbaniaforpunetomahabaleshwarhire />} />
<Route path="/urbania-for-pune-to-goa-tour-package" element={<Urbaniaforpunetogoatour />} />
<Route path="/urbania-for-pune-to-kolhapur-on-rent" element={<Urbaniaforpunetokolhapur />} />
<Route path="/urbania-for-pune-to-aurangabad-on-rent" element={<Urbaniaforpunetoaurangabad />} />
<Route path="/pune-to-lonavala-urbania-on-rent" element={<Punetolonavala />} />



<Route path="/urbania-on-rent-for-round-trip-pune" element={<Urbanionrentinforround />} />
<Route path="/urbania-traveller-rent-in-pune" element={<Urbaniatravellerrentinpune />} />
<Route path="/urbania-monthly-corporate-hire-pune" element={<Urbaniamonthlycorporatehire />} />
<Route path="/corporate-urbania-rental-services-pune" element={<Corporateurbaniarentalservice />} />
<Route path="/urbania-hire-for-picnic-in-pune" element={<Urbaniahireforpicnic />} />
<Route path="/urbania-hire-for-local-trip-in-pune" element={<Urbaniahireforlocaltripinpune />} />

<Route path="/urbania-on-rent-for-pune-airport" element={<Urbaniaonrentforpuneairport />} />
<Route path="/pune-to-mumbai-urbania-on-rent" element={<Punetomumbaiurbaniaonrent />} />
<Route path="/urbania-for-wedding-events-in-pune" element={<Urbaniaforweddingevents />} />
<Route path="/urbania-per-km-rate-in-pune" element={<Urbaniaperkmrateinoune />} />
<Route path="/cheapest-urbania-rental-service-in-pune" element={<Cheapesturbaniarentalservice />} />
<Route path="/ac-urbania-on-rent-in-akurdi-pune" element={<ACurbaniaonrrentinakurdi />} />
<Route path="/urbania-on-rent-in-wakad" element={<Urbaniaonrentinwakad />} />
<Route path="/luxury-urbania-on-rent-in-pashan" element={<Luxuryurbaniaonrentinpashan />} />
<Route path="/urbania-on-rent-in-balewadi" element={<Urbaniaonrentinbalewadii />} />
<Route path="/urbania-on-rent-in-sangvi" element={<Urbaniaonrentinsangvi />} />
<Route path="/urbania-bus-hire-in-chikhali" element={<Urbaniabushireinchikhali />} />
<Route path="/urbania-on-rent-in-talawade-midc" element={<Urbaniaonrentintalawade />} />
<Route path="/urbania-on-rent-in-purandar-airport" element={<Urbaniaonrentinpurandar />} />
<Route path="/urbania-on-rent-in-ravet-punawale" element={<Urbaniaonrentinravet />} />
<Route path="/urbania-on-rent-in-rajgurunagar-khed" element={<Urbaniaonrentinrajgurunagar />} />
<Route path="/urbania-bus-on-rent-in-junnar-pune" element={<Urbaniabusonrentinjunnar />} />
<Route path="/urbania-on-rent-in-ambegaon-pune" element={<Urbaniaonrentinambegaon />} />
<Route path="/urbania-bus-on-rent-in-shirur" element={<Urbaniabusonrent />} />
<Route path="/urbania-bus-hire-in-maval" element={<Urbaniaburhireinmaval />} />
<Route path="/urbania-on-rent-in-mulshi" element={<Urbaniaonrentinmulshi />} />
<Route path="/urbania-on-rent-in-daund" element={<Urbaniaonrentindaund />} />
<Route path="/urbania-on-rent-in-bhor" element={<Urbaniaonrentinbhor />} />
<Route path="/urbania-on-rent-in-purandar" element={<Urbaniaonrentpurandar />} />
<Route path="/urbania-on-rent-in-indapur" element={<Urbaniaonrentinindapur />} />
<Route path="/urbania-on-rent-in-velhe" element={<Urbaniaonrentinvelhe />} />
<Route path="/urbania-on-rent-in-mumbai" element={<Urbaniaonrentinmumbai />} />
<Route path="/force-urbania-on-rent-in-navi-mumbai" element={<Forceurbaniaonrentinnavimumbai />} />
<Route path="/luxury-urbania-bus-hire-in-thane" element={<Luxuryurbaniabushireinthane />} />
<Route path="/urbania-bus-on-rent-in-mumbai-airport" element={<Urbaniabusonrentinmumbai />} />
<Route path="/luxury-urbania-on-rent-in-lonavala" element={<Luxuryurbaniaonrentinlonavala />} />
<Route path="/urbania-on-rent-in-kolhapur" element={<Urbaniaonrentinkolhapur />} />


<Route path="/urbania-bus-on-rent-in-sangli" element={<Urbaniabusonrentinsangli />} />
<Route path="/urbania-bus-on-rent-in-solapur" element={<Urbaniabusonrentinsolapur />} />
<Route path="/urbania-bus-on-rent-in-shirdi" element={<Urbaniabusonrentinshirdi />} />
<Route path="/luxury-urbania-bus-rentals-in-nashik" element={<Luxuryurbaniabusrentalinnashik />} />
<Route path="/luxury-urbania-rentals-in-ahmednagar" element={<Luxuryurbaniarentalsinahemednagar />} />
<Route path="/ac-luxury-urbania-hire-in-mahabaleshwar" element={<Acluxuryurbaniahireinmahabaleshwar />} />
<Route path="/pune-to-konkan-darshan-urbania-bus-package" element={<Punetokonkandarshanurbaniabuspackage />} />
<Route path="/mini-bus-on-rent-in-pune" element={<Minibusonrentinpune />} />
<Route path="/mini-bus-on-rental-in-pimpri-chinchwad" element={<Minibusonrentalinpimprichichwad />} />
<Route path="/15-seater-ac-mini-luxury-bus-on-rent-pune" element={<Fifteenseateracminiluxury />} />
<Route path="/force-urbania-on-rent-in-satara" element={<Forceurbaniaonrentinsatara />} />
<Route path="/force-urbania-on-rent-in-katraj-pune" element={<Forceurbaniaonrentinkatrajpune />} />
<Route path="/force-urbania-on-rent-in-shivaji-nagar-pune" element={<Forceurbaniaonrentinshivajinagar />} />
<Route path="/urbania-on-rent-for-jyotirlinga-darshan-from-pune" element={<Urbaniaonrentforjyotilinga />} />
<Route path="/pune-to-ujjain-urbania-bus-hire" element={<Punetoujjainurbaniabushire />} />
<Route path="/pune-to-ashtavinayak-darshan-urbania-bus" element={<Punetoashtavinayakdarshan />} />
<Route path="/urbania-tourist-bus-on-rent-in-pune" element={<Urbaniatouristbusonrent />} />
<Route path="/pune-to-pandharpur-urbania-tour-package" element={<Punetopandharpururbaniatour />} />
<Route path="/urbania-bus-on-rent-in-nashik" element={<Urbaniabusonrentinnashik />} />
<Route path="/pune-to-ayodhya-urbania-bus-on-rent" element={<Punetoayodhyaurbaniabus />} />
<Route path="/pune-to-bhimashankar-urbania-hire" element={<Punetobhimashankar />} />
<Route path="/pune-to-hyderabad-urbania-on-rent" element={<Punetohyderabadurbania />} />
<Route path="/pune-to-bangalore-urbania-rental-service" element={<Punetobangloreurbania />} />
<Route path="/pune-to-rajasthan-urbania-rental-service" element={<Punetorajshthanurbania />} />
<Route path="/bus-on-rent-pune" element={<Busonrentinpune />} />
<Route path="/urbania-on-rent-in-aurangabad" element={<Urbaniaonrentinaurangabad />} />
<Route path="/bus-hire-for-wedding-in-pune" element={<Bushireforweddinginpune />} />
<Route path="/urbania-on-rent-pune-for-wedding-functions" element={<Urbaniaonrentpuneforwedding />} />
<Route path="/pune-to-outstation-urbania-on-rent" element={<Punetooutstationurbaniaonrent />} />
<Route path="/urbania-bus-on-rent-in-punawale" element={<Urbaniabusonrentinpunewala />} />
<Route path="/urbania-hire-in-pimpri-for-corporate-travel" element={<Urbaniahireinpimprichichwad />} />
<Route path="/urbania-on-rent-in-pune-contact-number" element={<Urbaniaonrentinpunecontact />} />
<Route path="/bus-rental-service-in-saswad-pune" element={<Busrentalserviceinsaswad />} />
<Route path="/9-seater-urbania-on-rent-in-pune" element={<Nineseaterurbaniaonrentinpune />} />
<Route path="/13-seater-urbania-on-rent-in-pune" element={<Onethreeseaterurbaniaonrentinpune />} />
<Route path="/10-seater-urbania-on-rent-in-pune" element={<Onezeroseaterurbaniaonrentinpune />} />
<Route path="/pune-to-nashik-urbania-bus-hire" element={<Punetonashikurbaniabushire />} />


      </Routes>



      <Footer />
    </Router>
  );
}

export default App;
